export const DELETE_MEAL_REQUEST = 'DELETE_MEAL_REQUEST';

export const deleteMealRequest = ( id: string ) => ({
    type: DELETE_MEAL_REQUEST,
    payload: { id }
});
